import React, { useEffect, memo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { actionCreators } from "./redux/pastDueCollectionsSagas";
import SectionToggle from "../../../../components/sectionToggle/sectionToggle";
import LoadingAnimation from "../../../../components/loadingAnimation/loadingAnimation";
import TableWithCustomSearch from "../../../../components/coreUiTableWithCustomSearchAndDateConversion/TableWithCustomSearch";
import { UpdateButtons } from "./smartComponents/UpdateButtons";
import DatePicker from "./smartComponents/DatePicker";
import CustomDateRanges from "./smartComponents/CustomDateRanges";
import { DataPoints } from "./smartComponents/DataPoints";
import PieCharts from "./smartComponents/PieCharts";
import "./pastDuesCollections.scss";

const PastDuesCollectionsModule = (props) => {
  const dispatch = useDispatch();

  const initialRequest = useSelector((state) => state.pastDuesCollections.initialRequest);
  const isLoading = useSelector((state) => state.pastDuesCollections.isLoading);
  const updatesLoading = useSelector((state) => state.pastDuesCollections.updatesLoading);

  const { data, colHeaders, columns, rawDataLink } = useSelector(
    (state) => state.pastDuesCollections.chartsData.table
  );

  useEffect(() => {
    !initialRequest && dispatch(actionCreators.fetchCurrentUser(props));
  }, []);

  const content = (
    <div>
      <div id="override-edit-selection-bar" className="edit-selections-bar">
        <div className="top-filter">
          <div />
          <div className="top-filter__right">
            <div className="select-box-no-width date-range-select-box">
              <p>Date Range</p>
              <CustomDateRanges />
            </div>

            <div className="date-select-box multi">
              <p>Date</p>
              <DatePicker />
            </div>
          </div>
        </div>

        <UpdateButtons />
      </div>
      <div data-testid="charts-container" className="chart-root">
        {updatesLoading ? (
          <LoadingAnimation text="Updating data..." />
        ) : (
          <>
            <DataPoints />
            <PieCharts />

            <TableWithCustomSearch
              fileName="past-dues"
              data={data}
              columns={columns}
              colHeaders={colHeaders}
              rawDataLink={rawDataLink}
              itemsPerPage={10}
            />
          </>
        )}
      </div>
    </div>
  );

  return (
    <div id="module-date-filters">
      <div id="past-dues-collections">
        <SectionToggle
          height={690}
          title="Past Dues Collections"
          isLoading={isLoading}
          content={content}
        />
      </div>
    </div>
  );
};

export default memo(PastDuesCollectionsModule);
